<div
  class="photo"
  (mouseenter)="hover = true"
  (mouseleave)="hover = false"
  [ngClass]="{ circular: isCircular }"
  >
  @if (hover) {
    <div class="overlay" (click)="changePhoto()"></div>
  }
  @if (!hover && !photo && !tempPreviewUrl) {
    <p>{{ title }}</p>
  }

  @if (photo || tempPreviewUrl) {
    <ca-circular-loader [progress]="progress">
      <ng-template>
        <ca-image-loader
          tappable
          [background]="false"
        [image]="
          tempPreviewUrl ||
          (photo?.modelId && photo?.modelName
            ? (photo | filedownloadurl | async)
            : null)
        "
          [fit]="fit"
        ></ca-image-loader>
      </ng-template>
    </ca-circular-loader>
  }
  <input
    (change)="processWebImage($event)"
    #fileInput
    type="file"
    accept="image/*"
    style="display: none"
    />
</div>
